"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingKeys = void 0;
var SettingKeys;
(function (SettingKeys) {
    SettingKeys["OAuthRefreshToken"] = "OAuthRefreshToken";
    SettingKeys["PnewdPasswordFileName"] = "PnewdPasswordFileName";
    SettingKeys["PnewdPasswordInitiateDate"] = "PnewdPasswordInitiateDate";
    SettingKeys["MarchingOrderAudioFilesExtensions"] = "MarchingOrderAudioFilesExtensions";
    SettingKeys["PortalsOwnersIdsWithoutPlantTreeBanner"] = "PortalsOwnersIdsWithoutPlantTreeBanner";
})(SettingKeys = exports.SettingKeys || (exports.SettingKeys = {}));
//# sourceMappingURL=setting-keys.js.map